import { Component } from '@angular/core';

import { AuthenticationService } from '../../services/index';

@Component({
    selector: 'app-sidebar',
    templateUrl: './sidebar.component.html',
    styleUrls: ['./sidebar.component.scss']
})
export class SidebarComponent {
    isActive = false;
    showMenu = '';
    activeMenus = [];

    constructor(private authService: AuthenticationService) {
        console.log('sidebar constructor');
    }

    eventCalled()
    {
        this.isActive = !this.isActive;
    }

    addExpandClass(element: any, level: number = 0)
    {
        if (element === this.activeMenus[level]) {
            // this.showMenu = '0';
            this.activeMenus[level] = '0';
        } else {
            // this.showMenu = element;
            this.activeMenus[level] = element;
        }

        this.activeMenus = this.activeMenus.splice(0, (level + 1));
    }
}



// WEBPACK FOOTER //
// /var/www/vhosts/s-wines.nl/httpdocs/crm/resources/assets/src/app/shared/components/sidebar/sidebar.component.ts